import { groupParamsByKey } from '@/js/utils/common';

export const getUrlParamsAsObject = () => {
    const array = new URLSearchParams(window.location.search);
    const object = groupParamsByKey(array);
    return object;
};

export function addProtocol(url) {
    if (!/^(?:f|ht)tps?:\/\//.test(url)) {
        url = 'https://' + url;
    }
    return url;
}

export const createUrlParamsObject = (urlParams) => {
    const urlParamsObject = {};
    for (const [key, value] of urlParams.entries()) {
        urlParamsObject[key] = value;
    }
    return urlParamsObject;
};

export const setUrlParamsFromObject = (obj: object | FormData, urlParams) => {
    const entries = 'entries' in obj
        ? obj.entries()
        : Object.entries(obj);
    for (const [key, value] of entries) {
        if (value !== '') {
            if (key.endsWith('[]')) {
                urlParams.append(key, value);
            } else {
                urlParams.set(key, value);
            }
        } else {
            urlParams.delete(key);
        }
    }
};

export const pushParamsToUrl = (params: URLSearchParams) => {
    window.history.pushState({}, '', window.location.pathname + '?' + params.toString());
};

export const siteUrl = (path: string) => {
    return document.location.protocol + '//' + document.location.host + '/' + path;
};
